import React, { useState, useEffect } from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import { useFormBuilder } from '../../../contexts/FormBuilderContext'; // <--- ИМПОРТ ХУКА
import styles from './QuestionEditor.module.css';
import { QUESTION_CONFIG } from '../questionTypes';
import { FiTrash2, FiCopy } from 'react-icons/fi';
import Switch from '../../common/Switch/Switch';
import Textarea from '../../common/Textarea/Textarea';
import Card from "../../common/Card/Card";

// Компонент больше не принимает колбэки через пропсы, только данные
const QuestionEditor = ({ question, questionNumber }) => {
    const intl = useIntl();
    // --- ПОЛУЧАЕМ ВСЕ НЕОБХОДИМЫЕ ФУНКЦИИ ИЗ КОНТЕКСТА ---
    const { updateQuestion, deleteQuestion, duplicateQuestion } = useFormBuilder();

    const [questionText, setQuestionText] = useState(question.text || '');
    const currentQuestionConfig = QUESTION_CONFIG.find(c => c.type === question.type);

    useEffect(() => {
        setQuestionText(question.text || '');
    }, [question.text]);

    const handleTextBlur = () => {
        if (questionText !== question.text) {
            updateQuestion(question.id || question.temp_id, { text: questionText });
        }
    };

    const handleRequiredToggle = () => {
        updateQuestion(question.id || question.temp_id, { is_required: !question.is_required });
    };

    const EditorComponent = currentQuestionConfig?.EditorComponent;

    const isPresentational = question.type === 'text_block';

    return (
        <Card className={`${styles.questionEditor} ${question.is_required ? styles.requiredHighlight : ''}`}>
            <div className={styles.questionHeader}>
                <span className={styles.questionNumber}>{questionNumber}.</span>
                {currentQuestionConfig?.icon && <currentQuestionConfig.icon className={styles.typeIcon} />}
                <Textarea
                    value={questionText}
                    onChange={(e) => setQuestionText(e.target.value)}
                    onBlur={handleTextBlur}
                    placeholder={intl.formatMessage({ id: 'question.placeholder' })}
                    className={styles.questionInput}
                    rows="1"
                    wrapperClassName={styles.noMarginBottom}
                />
            </div>

            <div className={styles.questionBody}>
                {EditorComponent && <EditorComponent question={question} />}
            </div>

            <div className={styles.questionFooter}>
                <div className={styles.actionsGroupLeft}>
                    {/*{question.is_required && <span className={styles.requiredIndicator}>* <FormattedMessage id="question.requiredLabel" /></span>}*/}
                </div>
                <div className={styles.actionsGroupRight}>
                    {!isPresentational && (
                    <Switch
                        id={`required-${question.id || question.temp_id}`}
                        checked={question.is_required || false}
                        onChange={handleRequiredToggle}
                        labelRight={intl.formatMessage({ id: "question.requiredLabel" })}
                    />
                    )}
                    <button onClick={() => duplicateQuestion(question.id || question.temp_id)} className={styles.footerButton} title={intl.formatMessage({ id: "question.duplicateTooltip" })}>
                        <FiCopy />
                    </button>
                    <button onClick={() => deleteQuestion(question.id || question.temp_id)} className={`${styles.footerButton} ${styles.deleteButton}`} title={intl.formatMessage({ id: "question.deleteTooltip" })}>
                        <FiTrash2 />
                    </button>
                </div>
            </div>
        </Card>
    );
};

export default QuestionEditor;
